
export const RECEIVE_QUESTION_GAME = 'RECEIVE_QUESTION_GAME'
export const RECEIVE_QUESTION_GAMES = 'RECEIVE_QUESTION_GAMES'
export const ASK_FINISHED = 'ASK_FINISHED'
export const QUESTION_ASKED = 'QUESTION_ASKED'
export const BET_STARTED = 'BET_STARTED'
export const BET_FINISHED = 'BET_FINISHED'

export const receiveQuestionGame = (question_game) => {
    return { type: RECEIVE_QUESTION_GAME , question_game }
}

export const askFinished = (game_id, question_id,  end_ask_date, userAnswersCount) => {
    return {type: ASK_FINISHED, question_id, game_id,  end_ask_date, userAnswersCount}
}

export const questionAsked = (game_id, question, msToAnswer, ask_date, currentQuestionIndex) => {
    return {type: QUESTION_ASKED, question, game_id, msToAnswer, ask_date, currentQuestionIndex}
}

export const betStarted = (game_id, question, betMs, start_bet_date, currentQuestionIndex) => {
    return {type: BET_STARTED, question, game_id, betMs, start_bet_date, currentQuestionIndex}
}

export const betFinished = (game_id, question_id, end_bet_date) => {
    return {type: BET_FINISHED, question_id, game_id, end_bet_date}
}

export const receiveQuestionGames = (question_games) => {
    return { type: RECEIVE_QUESTION_GAMES , question_games }
}


// WEBPACK FOOTER //
// ./src/reducers/questionGame/actions.js